import * as types from '@/store/mutationTypes';
import { NotificationsTypes } from '@/constants/notificationsTypes';
import { Notification } from '@/utils/notifications';

export const actions = {
    createNotification: ({ dispatch }, payload) => {
        const { message, type, timer } = payload;
        const notification = new Notification(message, type, timer);
        
        dispatch('saveNotification', notification);
    },

    saveNotification: ({ commit, dispatch }, payload) => {
        const { id, timer } = payload;
        commit(types.ADD_NOTIFICATION, payload);

        setTimeout(() => {
            dispatch('removeNotification', id)
        }, timer);
    },

    removeNotification: ({ commit }, payload) => {
        commit(types.REMOVE_NOTIFICATION, payload);
    },

    createSingleErrorNotification: ({ commit, dispatch }, payload) => {
        const { message } = payload;
        commit(types.CLEAR_NOTIFICATIONS);
        setTimeout(() => {
            dispatch('createNotification', { message: message, type: NotificationsTypes.ERROR });
        }, 800)
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/notifications/actions.js